import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, HasProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
// import { hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
// import { canAddToCart } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import { canAddToCart, hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface UOMSelectandQTYOrderedStyles {
    unitOfMeasureSelect?: SelectPresentationProps;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    quantityOrdered?: TextFieldProps;
    UnitOfMeasureGridItem?: GridItemProps;
    qtyOrderedGridItem?: GridItemProps;
    qtyOrderedWIthUoMGridItem?: GridItemProps;
    addToCartGridItem?: GridItemProps;
    addToListeGridItem?: GridItemProps;
    salesBlock?: InjectableCss;
}

export const unitOfMeasureSelectStyles: UOMSelectandQTYOrderedStyles = {
    mainContainer: {
        gap: 10,
        css: css`
            margin-top: 10px;
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 10px;
            `,
        },
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-top: 10px;
            `,
        },
    },
    UnitOfMeasureGridItem: {
        width: [6, 6, 6, 3, 3],
        css: css`
            padding-right: 0;
        `,
    },
    qtyOrderedGridItem: {
        width: [6, 6, 6, 3, 3],
        css: css`
            padding-right: 0;
        `,
    },
    qtyOrderedWIthUoMGridItem: {
        width: [6, 6, 6, 3, 3],
        css: css`
            padding-left: 0;
            padding-right: 0;
        `,
    },
    addToCartGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            padding-right: 0;
            padding-left: 0;
        `,
    },
    addToListeGridItem: {
        width: [12, 12, 12, 2, 2],
        css: css`
            align-items: center;
            justify-content: start;
            padding-right: 0;
            padding-left: 0;
        `,
    },
    salesBlock: {
        css: css`
            border: 2px solid;
            border-radius: 4px;
            padding: 5px;
            color: #f0b003;
            margin: 10px 0 3px;
            font-weight: bold;
            font-size: 14px;
            width: max-content;
        `,
    },
};

const styles = unitOfMeasureSelectStyles;

const UOMSelectandQTYOrdered: React.FC<Props> = ({ product, id }) => {
    const { unitOfMeasures, properties } = product;
    const isUoM = unitOfMeasures && unitOfMeasures.length ? unitOfMeasures.length : 0;

    return (
        <>
            {properties?.salesBlocked?.toLowerCase() === "true" ? (
                <StyledWrapper {...styles.salesBlock}>{siteMessage("sales_block_product_msg")}</StyledWrapper>
            ) : null}
            <GridContainer {...styles.mainContainer} data-test-selector="carousel_gridContainer">
                {product && isUoM >= 2 && (
                    <GridItem {...styles.UnitOfMeasureGridItem}>
                        <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />
                    </GridItem>
                )}
                <GridItem
                    {...(isUoM >= 2 ? { ...styles.qtyOrderedWIthUoMGridItem } : { ...styles.qtyOrderedGridItem })}
                >
                    <Zone zoneName="qtyOrdered" contentId={id} />
                </GridItem>

                <GridItem {...styles.addToCartGridItem}>
                    <Zone zoneName="addToCartButton" contentId={id} />
                </GridItem>
                <GridItem {...styles.addToListeGridItem}>
                    <Zone zoneName="addToListButton" contentId={id} />
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(UOMSelectandQTYOrdered),
    definition: {
        displayName: "UOM and Quantity Ordered",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
